<template>
    <div class="row">
        <div class="col">
            <clear-all></clear-all>
        </div>
    </div>
</template>

<script>
    import ClearAll from './settings/ClearAll'

    export default {
        components: {
            ClearAll
        }
    }
</script>
